import Vue from 'vue'
import pagesJson from "@/data/pages.json";

export default {

	SET_USER_NAME(state, value) {
		state.user.name = value;
	},

    SET_USER_KEY(state,value){
        state.user.key = value;
    },

	SET_CONTROLLER(state, value) {
		state.user.isController = value;
	},

	SET_CONTROLLER_HINT(state, value) {
		state.showControllerHint = value;
	},

	SET_CONTROLLER_PAGE(state, value) {
		state.showControllerPage = value;
	},

	SET_ADMIN(state, value) {
		state.user.isAdmin = value;
	},


	USER_LIST_UPDATE(state, dataSnapshot) {
		state.usersObj[dataSnapshot.key] = dataSnapshot.val();
	},

	SET_VOLUME_HINT(state, value) {
		state.showVolumeControls = value;
	},

	SET_CONTROLLER_KEY(state, value) {
		state.controllerKey = value;
	},

	SET_HELP(state, value) {
		state.requestingHelp = value;
	},

	SET_HELP_HINT(state, value) {
		state.requestingHelpHint = value;
	},

	SET_COUNTDOWN_TARGET(state, value) {
		state.countdownTarget = value;
	},

	SET_COUNTDOWN_TIMER(state, value) {
		state.countdownTimer = value;
	},

	SET_COUNTDOWN(state, value) {
		state.countdown = value;
	},

	SET_SESSION_REF(state, value) {
		state.sessionRef = value;
	},

	SET_CONNECTION_STATUS(state, value) {
		state.connectionStatus = value;
	},

	SET_SESSION_AND_SCENARIO(state, payload) {
		//
		state.session.passcode = payload.ParticipantCode;
		state.session.operatorCode = payload.OperatorCode;
		state.session.id = payload.ID;
		state.session.axis = payload.Axis;
		state.session.isLocked = (payload.isLocked) ? true : false;
		state.session.roomUrl = payload.roomUrl;
		state.session.hostRoomUrl = payload.hostRoomUrl;
		//
		state.scenario.name = payload.scenario.name;
		state.scenario.adversaryTask = payload.scenario.adversaryTask;
		state.scenario.advocateTask = payload.scenario.advocateTask;
		state.scenario.adversaryRoles = payload.scenario.adversaryRoles;
		state.scenario.advocateRoles = payload.scenario.advocateRoles;
		state.scenario.adversaryHints = payload.scenario.adversaryHints;
		state.scenario.advocateHints = payload.scenario.advocateHints;
		state.scenario.adversaryTactics = payload.scenario.adversaryTactics;
		state.scenario.advocateTactics = payload.scenario.advocateTactics;
		state.scenario.video = payload.scenario.video;
	},

	SET_ACTIVE_TACTIC(state, tactic) {
		// can be 'null' when we are closing the page
		if (tactic) {
			Vue.set(tactic, 'active', true);
		}
	},

	UNSET_ACTIVE_TACTIC(state) {
		// loop through all tactics and unset active property
		state.scenario.advocateTactics.forEach(tactic => {
			Vue.delete(tactic, 'active');
		});
		state.scenario.adversaryTactics.forEach(tactic => {
			Vue.delete(tactic, 'active');
		});
	},


	SET_PAGE(
		state, newPageName) {
		// validate
		if (!pagesJson.find(p => p.name === newPageName)) {
			throw new Error("GOTO: '" + newPageName + "' is not a valid page name");
		}
		state.pageName = newPageName;
	},

	SET_HINT(state, hintText) {
		state.hintText = hintText;
	},

	SET_SIDE(state, value) {
		state.side = value;
	},

	SET_DIFFICULTY(state, value) {
		state.difficulty = value;
	},

	SET_VISION(state, value) {
		state.visionText = value;
	},

	SET_MOTIVATION(state, value) {
		state.motivationText = value;
	},

	SET_IMPACT(state, value) {
		state.impactText = value;
	},

	SET_METHOD(state, value) {
		state.methodText = value;
	},

	SET_TARGET(state, value) {
		state.targetText = value;
	},

	SET_OBJECTIVE(state, value) {
		state.objectiveText = value;
	},

	SET_ARCHETYPE_OTHER(state, value) {
		state.archetypeOtherText = value;
	},

	SET_ARCHETYPE(state, payload) {
		if (typeof payload !== 'object') {
			throw "'archetype should be object {index:'', title:'', text:''}";
		}
		state.selectedArchetype.index = payload.index;
		state.selectedArchetype.title = payload.title;
		state.selectedArchetype.text = payload.text;
	},

	SET_ROLE_OTHER(state, value) {
		state.roleOtherText = value;
	},

	SET_ROLE(state, payload) {
		if (typeof payload !== 'object') {
			throw "payload should be object {index:'', title:'', text:''}";
		}
		state.selectedRole.index = payload.index;
		state.selectedRole.title = payload.title;
		state.selectedRole.text = payload.text;
	},

	SET_ROLE_TAB(state, value) {
		state.roleActiveTab = value;
	},

	SET_STRATEGY_TAB(state, value) {
		state.strategyActiveTab = value;
	},

	SET_CONFIRM_TAB(state, value) {
		state.confirmActiveTab = value;
	},

	SET_FEEDBACK(state, object) {
		state.feedback.splice(object.q, 1, object.a)
	},

	SET_ALL_FEEDBACK(state, value) {
		state.feedback = value;
	},

	SET_FEEDBACK_TAB(state, value) {
		state.feedbackActiveTab = value;
	},

	SET_USERS(state, value) {
		Vue.set(state, 'usersObj', value);
	},

	ADD_USER(state, payload) {
		Vue.set(state.usersObj, payload.key, payload.value);
	},

	REMOVE_USER(state, key) {
		Vue.delete(state.usersObj, key);
	},

	ADD_VIDEO_DOWNLOAD_URL(state, payload) {
		// Vue.set(state.videoDownloadURLs, payload.filename, payload.downloadURL);
		state.videoDownloadURLs[payload.filename] = payload.downloadURL;
	},




	saveName(state, value) {
		// state.names[value.index] = value.name;
		Vue.set(state.names, value.index, value.name);
	},



}
